import React, { useMemo } from "react";
import SyncProblemOutlinedIcon from "@mui/icons-material/SyncProblemOutlined";
import { ButtonTypes } from "../../../../../components/Button";

import { ledgerCaveatsOf } from "./ledgerCaveats";
import { SetPriceButton, StripText, Strips, WarningStrip } from "./styles";
import { ValuationStripsProps } from "./types";

const ValuationStripsComponent: React.FC<ValuationStripsProps> = ({
  investment,
  holdings,
  onSetPrice,
}) => {
  const caveats = useMemo(
    () => ledgerCaveatsOf(investment, holdings),
    [investment, holdings],
  );

  if (caveats.length === 0) {
    return null;
  }

  return (
    <Strips>
      {caveats.map(({ key, lead, detail, repairable }) => (
        <WarningStrip key={key} role="status">
          <SyncProblemOutlinedIcon aria-hidden />
          <StripText>
            <strong>{lead}</strong> {detail}
          </StripText>
          {repairable && (
            <SetPriceButton
              type={ButtonTypes.link}
              size="small"
              onClick={() => onSetPrice(repairable)}
            >
              Set price
            </SetPriceButton>
          )}
        </WarningStrip>
      ))}
    </Strips>
  );
};

export const ValuationStrips = React.memo(ValuationStripsComponent);
